export interface DischargeChecklistItem {
  id: string;
  label: string;
  position: number;
  groupTypeId: string;
  updatedAt: string;
  updatedByName: string | null;
}

// One per level of care with Discharge Planning on. `name` is the level of care's short name
// (SNF, LTC), which is what the tabs show.
export interface DischargeChecklist {
  groupType: { id: string; name: string };
  items: DischargeChecklistItem[];
}

export enum DischargeChecklistState {
  OPEN = 'open',
  DONE = 'done',
  NOT_NEEDED = 'not_needed',
}

// An item's one current note. Earlier versions are in its history.
export interface DischargeChecklistNote {
  text: string;
  createdByName: string;
  createdAt: string;
}

// One item on a patient's checklist, with its label read live from configuration. `note` is sent only
// where notes are shown (the patient story), so it can be absent.
export interface DischargeChecklistEntry {
  itemId: string;
  label: string;
  state: DischargeChecklistState;
  note?: DischargeChecklistNote | null;
}

export enum DischargeChecklistHistoryOperation {
  CHECKED = 'checked',
  UNCHECKED = 'unchecked',
  MARKED_NOT_NEEDED = 'marked_not_needed',
  MARKED_NEEDED = 'marked_needed',
  NOTE_ADDED = 'note_added',
  NOTE_UPDATED = 'note_updated',
}

// One change to one item. The name and label are as they were when the change was made.
export interface DischargeChecklistHistoryEntry {
  id: string;
  operation: DischargeChecklistHistoryOperation;
  noteText: string | null;
  itemLabel: string | null;
  createdAt: string;
  createdByName: string | null;
}

// A patient's checklist as the API sends it on their projected discharge review. `total` leaves out
// items marked not needed, so 5 items with 2 done and 1 not needed is done 2, total 4.
export interface DischargeChecklistSummary {
  done: number;
  total: number;
  items: DischargeChecklistEntry[];
}
